__turbopack_context__.v({
  "statusTooltipContent": "StatusTooltipContent-module__NxMA2a__statusTooltipContent",
});
